import { Card, CardHeader, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PropertyList } from '../../../../components/atoms/property-list';
import { PropertyListItem } from '../../../../components/atoms/property-list-item';
import { getTranslationBasedOnLanguage } from '../../../../utils/get-translation-based-on-language';
import { VisitState } from '../../api/types/visits';

import { OrganizationLanguage } from '@/features/settings/api/types/gdpr';
import { VisitSource } from '@/features/visitors/api/types/visitor';
import { getConfirmationStatus } from '@/utils/get-confirmation-status';

interface Props {
  category: {
    en: string;
    pl: string;
  };
  source?: VisitSource;
  hostConfirmed?: boolean | null;
  deviceConfirmed?: boolean | null;
  visitState?: VisitState;
}

export const VisitReason = ({
  category,
  source,
  hostConfirmed,
  deviceConfirmed,
  visitState,
}: Props) => {
  const { t, i18n } = useTranslation(['visit', 'visits', 'common']);

  const hostConfirmationStatus = getConfirmationStatus({
    hostConfirmed,
    deviceConfirmed,
    visitState,
  });

  return (
    <Card variant="outlined">
      <CardHeader title={t('visit:reason.title')} />
      <Divider />
      <PropertyList>
        <PropertyListItem
          label={t('visit:reason.category')}
          value={getTranslationBasedOnLanguage(category, i18n.language as OrganizationLanguage)}
        />
        <PropertyListItem
          label={t('visits:table.columns.source')}
          value={source ? t(`visits:source.${source}`) : 'N/A'}
        />
        <PropertyListItem
          label={t('visits:table.columns.confirmed')}
          value={hostConfirmationStatus ? t(hostConfirmationStatus) : 'N/A'}
        />
      </PropertyList>
    </Card>
  );
};
